import { useCallback, useEffect, useRef } from 'react'

import { useActiveApp } from 'shared/hooks/useActiveApp'
import { getWindowIframe } from 'shared/utils/getWindowIframe'

import { insertAtCursor } from '../utils/insertAtCursor'
import { SttMessageType } from '../utils/sttMessageTypes'
import type { SttSegment, SttStatus } from './useSttStream'

const buildResult = (segments: SttSegment[]) =>
  segments.map(s => s.correctedText ?? s.rawText).join(' ')

export const useSttResult = (status: SttStatus, segments: SttSegment[]) => {
  const activeApp = useActiveApp()
  const segmentsRef = useRef(segments)
  const prevStatusRef = useRef(status)
  segmentsRef.current = segments

  const handleResult = useCallback(
    (result: string) => {
      switch (activeApp?.type) {
        case 'window': {
          const iframe = getWindowIframe(activeApp.app.id)
          if (iframe) {
            iframe.contentWindow?.postMessage(
              { type: SttMessageType.Result, result },
              process.env.REACT_APP_CONTAINER_DOMAIN!
            )
          }
          break
        }
        case 'detached':
          insertAtCursor(result)
          break
        default:
          break
      }
    },
    [activeApp]
  )

  useEffect(() => {
    const prev = prevStatusRef.current
    prevStatusRef.current = status
    if (
      (prev === 'recording' || prev === 'finalizing') &&
      status === 'stopped'
    ) {
      const result = buildResult(segmentsRef.current)
      if (result.trim()) handleResult(result)
    }
  }, [status, handleResult])
}
